import { combineReducers } from "redux";
import dashboardReducer from "./dashboardReducer";
import authReducer from "./authReducer";
import empReducer from "./empReducer";
import incidentReducer from "./incidentReducer";
import reportsReducer from "./reportsReducer";
import administrationReducer from "./administrationReducer";
import investigationsReducer from "./investigationReducer";
import auditReducer from "./auditReducer";
import picklistReducer from "./picklistReducer";
import emailReducer from "./emailReducer";

export default combineReducers({
  dashboard: dashboardReducer,
  auth: authReducer,
  emp: empReducer,
  incident: incidentReducer,
  admin: administrationReducer,
  investigations: investigationsReducer,
  reports: reportsReducer,
  audits: auditReducer,
  picklist: picklistReducer,
  email: emailReducer,
});
